export default __webpack_public_path__ + "static/media/resources.01d5384c.png";